import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import spotFormEscl from '../../../locales/es-CL/spotForm.json';
import spotFormEsmx from '../../../locales/es-MX/spotForm.json';
import spotFormEsco from '../../../locales/es-CO/spotForm.json';
import spotFormEnus from '../../../locales/en-US/spotForm.json';
import axios from 'axios';
import moment from 'moment';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import ProgressBar from '../../../components/ProgressBar.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Container from 'typedi';
import LogService from '../../../services/LogService';
import spotForm from '../../../components/SpotForm.vue';

export default {
  name: 'DateAndDepotProcess',
  components: {
    GoogleMapsApiLoader,
    spotForm,
    VueCtkDateTimePicker,
    DatePicker,
    ProgressBar,
  },
  props: {
    planificationId: {
      type: String,
      default: null,
    },
    planificationState: {
      type: String,
      default: null,
    },
    planificationOngoing: {
      type: Boolean,
      default: false,
    },
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
        spotForm: spotFormEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
        spotForm: spotFormEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
        spotForm: spotFormEsco,
      },
      'en-US': {
        planification: planificationEnus,
        spotForm: spotFormEnus,
      },
    },
  },
  data() {
    return {
      optionSpots: [],
      logService: null,
      actualStep: 'date',
      planIsOngoing: false,
      isMainPageBussy: false,
      endDepotRequired: false,
      startDepotRequired: false,
      isEndDepotRequired: false,
      emptyExecutionDate: false,
      lowerExecutionDate: false,
      lastHourLower: false,
      emptyInitHour: false,
      emptyEndHour: false,
      optimizationOutput: null,
      optimizationInput: null,
      namePlanification: null,
      gapi: null,
      operations: [],
      dataAccess: null,
      form: {
        executionDate: '',
        planificationName: null,
        initHour: '',
        endHour: '',
      },
      depotOrigin: null,
      depotDestination: null,
      showAlert: false,
      trafficFactorOptions: [
        // 1.01 para que no sea automático
        { factor: 1, name: this.$t('planification.solver.trafficFactor.dinamic') },
        { factor: 1.01, name: this.$t('planification.solver.trafficFactor.low') },
        { factor: 1.5, name: this.$t('planification.solver.trafficFactor.medium') },
        { factor: 2, name: this.$t('planification.solver.trafficFactor.high') },
        { factor: 3, name: this.$t('planification.solver.trafficFactor.veryhigh') },
      ],
      trafficFactor: { factor: 1, name: this.$t('planification.solver.trafficFactor.dinamic') },
    };
  },
  beforeRouteLeave(to, from, next) {
    const allowedRoutes = [
      'OperationProcess',
      'OperationProcessNotOngoing',
      'DateAndDepotProcess',
      'DateAndDepotProcessNotOngoing',
      'ResourceProcess',
      'ResourceProcessNotOngoing',
      'RouteProcess',
      'RouteProcessNotOngoing',
      'PlanificationBuilder',
      'PlanificationBuilderNotOngoing',
    ];
    if (!allowedRoutes.includes(to.name)) {
      this.$store.commit('setMetaData', null); // Limpia los datos si no es una ruta permitida
      this.$store.commit('setInputOptimization', null);
      this.$store.commit('setOututOptimization', null);
    }
    next(); // Permite la navegación
  },
  created() {
    this.dataAccess = this.$store.getters.dataAccess;
    this.logService = Container.get(LogService);
    if (this.jsonData && this.jsonData.gapi) {
      this.gapi = this.jsonData.gapi;
    } else {
      GoogleMapsApiLoader({
        libraries: ['places', 'marker'],
        apiKey: this.$store.getters.apiKey,
      }).then((google) => {
        this.gapi = google;
      });
    }
    this.preparedData();
  },
  methods: {
    async preparedData() {
      this.isMainPageBussy = true;
      //Esto es para setear los datos si es que estoy volviendo de otra vista
      this.$set(this, 'form', this.jsonData.form ?? this.form);
      if (!this.form.executionDate) {
        this.form.executionDate = moment(new Date()).format('YYYY-MM-DD');
        console.log('Fecha automatica ', this.form.executionDate);
      }
      //Esto es para checkear si es que hay operaciones de tipo collection
      this.$set(this, 'operations', this.jsonData.operations ?? this.operations);
      if (this.operations.length > 0) {
        this.isEndDepotRequiredCheck();
      }
      await this.getDestinations();
      this.buildDefaultDepots();
      if (this.planificationId) {
        const { inputOptimization, outputOptimization } = this.$store.getters;
        const inputOptimizationStr = JSON.stringify(inputOptimization || {});
        const outputOptimizationStr = JSON.stringify(outputOptimization || {});
        this.optimizationInput = JSON.parse(inputOptimizationStr);
        this.optimizationOutput = JSON.parse(outputOptimizationStr);

        this.planIsOngoing = this.planificationState === 'STARTED' || this.planificationState === 'ONGOING';
        this.namePlanification =
          this.optimizationInput && 'name' in this.optimizationInput ? this.optimizationInput.name : this.form.name;
      } //Esta condición es si acaso vengo devolviendome de otra vista, lo que evita ir por la información de la planificación nuevamente
      if (this.jsonData.depotOrigin || this.jsonData.depotDestination || this.jsonData.trafficFactor) {
        console.log('Refrescando data desde otro estado ', this.jsonData);
        this.updateDataFromOtherStages();
      } else if (this.planificationId) {
        this.preparedEditMode(this.optimizationInput);
      }
      this.isMainPageBussy = false;
    },
    buildDefaultDepots() {
      if (this.optionSpots.length == 1) {
        this.depotOrigin = this.optionSpots[0];
        if (this.isEndDepotRequired) {
          this.depotDestination = this.optionSpots[0];
        }
      }
    },
    async isEndDepotRequiredCheck() {
      this.isEndDepotRequired = this.operations.some((operation) => operation.typeOperation.type === 'COLLECTION');
    },
    updateDataFromOtherStages() {
      this.depotOrigin = this.jsonData.depotOrigin ?? this.depotOrigin;
      this.depotDestination = this.jsonData.depotDestination ?? this.depotDestination;
      this.trafficFactor = this.jsonData.trafficFactor ?? this.trafficFactor;
    },
    preparedEditMode(inputOptimization) {
      this.form.executionDate = moment(new Date(inputOptimization.startDate)).format('YYYY-MM-DD');
      this.form.initHour = moment(new Date(inputOptimization.startDate)).format('HH:mm:ss');
      this.form.endHour = moment(new Date(inputOptimization.endDate)).format('HH:mm:ss');

      //Si  rellena las variables globales de depot de inicio
      let depotStart = inputOptimization.depots[0];
      this.depotOrigin = this.optionSpots.find((spot) => spot.id === depotStart.extraInfo.id);

      //Si posee depot de destino rellena las variables globales de depot de destino
      if (inputOptimization.depots.length > 1) {
        let depotDestination = inputOptimization.depots[1];
        this.depotDestination = this.optionSpots.find((spot) => spot.id === depotDestination.extraInfo.id);
      }
      this.trafficFactor = this.trafficFactorOptions.find((tf) => tf.factor == 1.01);
      if (inputOptimization.parameters && inputOptimization.parameters.trafficFactor) {
        const factorObject = this.trafficFactorOptions.find(
          (tf) => tf.factor == inputOptimization.parameters.trafficFactor,
        );
        if (factorObject) {
          this.trafficFactor = factorObject;
        }
      }
    },

    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.optionSpots = response.data.data;
        this.setDestinationsAddressStreet();
        this.sortSpotList();
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getdestinations fallo el obtener los destinos ${e.message}`,
        });
        this.optionSpots = [];
      }
    },
    sortSpotList() {
      this.optionSpots.sort(function (a, b) {
        let nameA = a.name.toUpperCase(); // Convertimos a mayúsculas para ignorar mayúsculas y minúsculas
        let nameB = b.name.toUpperCase();
        if (nameA > nameB) {
          return 1;
        }
        if (nameA < nameB) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    /**
     * Metodo que obtiene la calle de los destinos.
     */
    setDestinationsAddressStreet() {
      this.optionSpots.forEach((destination) => {
        destination.addressStreet = destination.address.street;
      });
    },
    async getGeoFences() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getGeoFences obteniendo geocercas del cliente`,
        });
        this.isGeoFenceBussy = true;
        const response = await axios.get(`${this.$store.getters.urlAPI}/geofence?onlyActives=true`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.geoFence = response.data.data;
        this.geoFence.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        console.log(this.geoFence);
        if (this.geoFence.length > 0) {
          this.getVehicleGeofence();
          if (this.planificationId && this.useGeoFence) {
            this.syncVehicleGeofence();
          }
        }
        this.isGeoFenceBussy = false;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getGeoFences fallo el servicio ${e.message}`,
        });
        this.isGeoFenceBussy = false;
        this.geoFence = [];
        console.log(e);
      }
    },
    async chooseVehicles() {
      if (this.validateDates() && this.validateFormOrigin()) {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `chooseVehicles viajando a la sección de recursos`,
          data: {
            depotOrigin: this.depotOrigin,
            depotDestination: this.depotDestination,
          },
        });
        this.$store.commit('setMetaData', {
          form: this.form,
          depotOrigin: this.depotOrigin,
          depotDestination: this.depotDestination,
          trafficFactor: this.trafficFactor,
        });
        this.$store.commit('setInputOptimization', this.optimizationInput);
        this.$store.commit('setOututOptimization', this.optimizationOutput);
        if (this.planificationId) {
          this.$router.push({
            name: 'ResourceProcess',
            params: {
              planificationId: this.planificationId,
              planificationState: this.planificationState,
              planificationOngoing: this.planIsOngoing,
            },
          });
        } else {
          this.$router.push({
            name: 'ResourceProcessNotOngoing',
            params: {
              planificationId: this.planificationId,
              planificationState: this.planificationState,
              planificationOngoing: this.planIsOngoing,
            },
          });
        }
      }
    },

    backActivies() {
      this.actualStep = 'operation';
      this.$store.commit('setMetaData', {
        form: this.form,
        depotOrigin: this.depotOrigin,
        depotDestination: this.depotDestination,
        trafficFactor: this.trafficFactor,
      });
      this.$store.commit('setInputOptimization', this.optimizationInput);
      this.$store.commit('setOututOptimization', this.optimizationOutput);
      if (this.planificationId) {
        this.$router.push({
          name: 'OperationProcess',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      } else {
        this.$router.push({
          name: 'OperationProcessNotOngoing',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      }
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    newSpotActivated(spot, path) {
      if (spot !== null && spot.id === -1) {
        this.temporalSpotPath = path;
        this.temporalSpotRequired = true;
        this.showModal('create-temporal-spot-modal');
      } else {
        this.temporalSpotRequired = false;
      }
    },
    depotToUse(newDepot) {
      if (this.temporalSpotPath === 'origin') {
        this.depotOrigin = newDepot;
      } else if (this.temporalSpotPath === 'destination') {
        this.depotDestination = newDepot;
      }
    },
    closeSpotForm() {
      if (this.temporalSpotPath === 'origin') {
        this.depotOrigin = null;
      } else if (this.temporalSpotPath === 'destination') {
        this.depotDestination = null;
      }
      this.closeModal('create-temporal-spot-modal');
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    validateFormOrigin() {
      if (this.depotOrigin && this.depotOrigin.id !== -1) {
        if (this.isEndDepotRequired) {
          if (this.depotDestination && this.depotDestination.id !== -1) {
            this.startDepotRequired = false;
            this.endDepotRequired = false;
            this.showAlert = false;
            return true;
          } else {
            this.startDepotRequired = false;
            this.endDepotRequired = true;
            this.showAlert = true;
            this.showPopover('endDepot');
            //showAlert('Error', 'Debes indicar la bodega de destino para operaciones de retiro', 'error');
          }
        } else {
          this.startDepotRequired = false;
          this.endDepotRequired = false;
          this.showAlert = false;
          return true;
        }
      } else {
        if (this.isEndDepotRequired) {
          if (this.depotDestination && this.depotDestination.id !== -1) {
            this.startDepotRequired = true;
            this.endDepotRequired = false;
            this.showAlert = true;
            this.showPopover('startDepot');
            //showAlert('Error', 'Debes indicar la bodega de origen', 'error');
          } else {
            this.startDepotRequired = true;
            this.endDepotRequired = true;
            this.showAlert = true;
            this.showPopover('startDepot');
            this.showPopover('endDepot');
            //showAlert('Error', 'Debes indicar la bodega de origen y la bodega de destino para operaciones de retiro', 'error');
          }
        } else {
          this.startDepotRequired = true;
          this.endDepotRequired = false;
          this.showAlert = false;
          this.showPopover('startDepot');
          //showAlert('Error', 'Debes indicar la bodega de origen', 'error');
        }
      }
    },
    validateDates() {
      let executionDate = this.validateExecutionDate();
      let initHour = this.validateInitHour();
      let endHour = this.validateEndHour();
      return executionDate && initHour && endHour && this.validateDateValid();
    },
    validateDateValid() {
      //Si estoy en curso no podre editar este campo asi que la validacion no se considerara
      if (this.planIsOngoing) {
        this.lowerExecutionDate = false;
        return true;
      }
      let today = moment(new Date().getTime()).format('YYYY-MM-DD');
      if (this.form.executionDate >= today) {
        this.lowerExecutionDate = false;
        if (this.form.initHour < this.form.endHour) {
          this.lastHourLower = false;
          return true;
        } else {
          this.lastHourLower = true;
        }
      }
      this.lowerExecutionDate = true;
      return false;
    },
    validateExecutionDate() {
      if (this.form.executionDate && this.form.executionDate != null) {
        this.emptyExecutionDate = false;
        return true;
      }
      this.emptyExecutionDate = true;
      return false;
    },
    validateInitHour() {
      if (this.form.initHour && this.form.initHour != null) {
        this.emptyInitHour = false;
        return true;
      }
      this.emptyInitHour = true;
      return false;
    },
    validateEndHour() {
      if (this.form.endHour && this.form.endHour != null) {
        this.emptyEndHour = false;
        return true;
      }
      this.emptyEndHour = true;
      return false;
    },
  },
  computed: {
    jsonData() {
      return this.$store.getters.jsonDataPlanification || {};
    },
    renderedOrigins() {
      return [
        {
          id: -1,
          name: 'Crear nueva bodega',
          addressStreet: null,
        },
        ...this.optionSpots,
      ];
    },
  },
  watch: {},
};
